export enum EmployeeStatusesEnum {
  Current = 'Current',
  Archived = 'Archived',
}
